import { render, staticRenderFns } from "./WalletCardColorSelect.vue?vue&type=template&id=9dc470e4&scoped=true&"
import script from "./WalletCardColorSelect.vue?vue&type=script&lang=js&"
export * from "./WalletCardColorSelect.vue?vue&type=script&lang=js&"
import style0 from "./WalletCardColorSelect.vue?vue&type=style&index=0&id=9dc470e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc470e4",
  null
  
)

export default component.exports